<template>
  <div class="about-page">
    <b-container class="py-5">
      <h1 class="mb-4 text-center">{{ $t('about.title') }}</h1>
      
      <div class="content shadow-sm p-4 bg-white rounded">
        <section class="mb-5">
          <h2 class="h4 font-weight-bold mb-3">{{ $t('about.mission_title') }}</h2>
          <p>{{ $t('about.mission_desc') }}</p>
        </section>

        <section class="mb-5">
          <h2 class="h4 font-weight-bold mb-3">{{ $t('about.who_title') }}</h2>
          <p>{{ $t('about.who_desc_1') }}</p>
          <p>{{ $t('about.who_desc_2') }}</p>
        </section>

        <section class="mb-5">
          <h2 class="h4 font-weight-bold mb-3">{{ $t('about.philosophy_title') }}</h2>
          <ul>
            <li><strong>{{ $t('about.philosophy_transparency') }}</strong>: {{ $t('about.philosophy_transparency_desc') }}</li>
            <li><strong>{{ $t('about.philosophy_user') }}</strong>: {{ $t('about.philosophy_user_desc') }}</li>
            <li><strong>{{ $t('about.philosophy_innovation') }}</strong>: {{ $t('about.philosophy_innovation_desc') }}</li>
          </ul>
        </section>

        <section>
          <h2 class="h4 font-weight-bold mb-3">{{ $t('about.why_title') }}</h2>
          <ul>
            <li><strong>{{ $t('about.why_rates') }}</strong>: {{ $t('about.why_rates_desc') }}</li>
            <li><strong>{{ $t('about.why_savings') }}</strong>: {{ $t('about.why_savings_desc') }}</li>
            <li><strong>{{ $t('about.why_global') }}</strong>: {{ $t('about.why_global_desc') }}</li>
          </ul>
        </section>

        <div class="mt-5 text-center">
            <p class="lead font-weight-bold text-success">{{ $t('about.call_to_action') }}</p>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>
.content {
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
}
</style>
